var _defs, _g, _g2, _g3, _path, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GOOGLE_PLAY",
    "data-name": "GOOGLE PLAY",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120.281,
    height: 35.639,
    viewBox: "0 0 120.281 35.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.907,
    y1: 58.368,
    x2: -0.384,
    y2: 59.039,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.077,
    y1: 172.029,
    x2: -1.307,
    y2: 172.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.863,
    y1: 113.301,
    x2: -0.5,
    y2: 115.067,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: 113.109,
    x2: 0.421,
    y2: 113.901,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M115.826,35.639H4.455A4.412,4.412,0,0,1,0,31.184V4.455A4.412,4.412,0,0,1,4.455,0H115.826a4.412,4.412,0,0,1,4.455,4.455V31.184A4.412,4.412,0,0,1,115.826,35.639Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M115.826.713a3.765,3.765,0,0,1,3.742,3.742V31.184a3.765,3.765,0,0,1-3.742,3.742H4.455A3.765,3.765,0,0,1,.713,31.184V4.455A3.765,3.765,0,0,1,4.455.713H115.826m0-.713H4.455A4.468,4.468,0,0,0,0,4.455V31.184a4.412,4.412,0,0,0,4.455,4.455H115.826a4.412,4.412,0,0,0,4.455-4.455V4.455A4.468,4.468,0,0,0,115.826,0Z",
    fill: "#a6a6a6"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(36.886 6.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M46.746,9.84a2.427,2.427,0,0,1-.624,1.782A2.762,2.762,0,0,1,41.4,9.662,2.738,2.738,0,0,1,44.162,6.9a2.372,2.372,0,0,1,1.069.267,1.94,1.94,0,0,1,.8.624l-.445.445a1.661,1.661,0,0,0-1.426-.624,1.773,1.773,0,0,0-1.426.624,1.835,1.835,0,0,0-.624,1.515,1.835,1.835,0,0,0,.624,1.515,2.294,2.294,0,0,0,1.426.624,1.954,1.954,0,0,0,1.515-.624,1.475,1.475,0,0,0,.445-1.069h-1.96V9.484h2.584Z",
    transform: "translate(-41.4 -6.9)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M51.618,7.624H49.213V9.317H51.44V9.94H49.213v1.693h2.406v.713H48.5V7h3.118Z",
    transform: "translate(-42.174 -6.911)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M55.027,12.346h-.713V7.624H52.8V7h3.742v.624H55.027Z",
    transform: "translate(-42.643 -6.911)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M59.9,12.346V7h.713v5.346Z",
    transform: "translate(-43.417 -6.911)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M63.827,12.346h-.713V7.624H61.6V7h3.653v.624H63.738v4.722Z",
    transform: "translate(-43.602 -6.911)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M73.022,11.622A2.762,2.762,0,0,1,68.3,9.662a2.762,2.762,0,1,1,5.524,0A2.62,2.62,0,0,1,73.022,11.622Zm-3.386-.445a2.1,2.1,0,0,0,1.426.624,1.773,1.773,0,0,0,1.426-.624,2.149,2.149,0,0,0,.624-1.515,1.835,1.835,0,0,0-.624-1.515,2.1,2.1,0,0,0-1.426-.624,1.773,1.773,0,0,0-1.426.624,2.15,2.15,0,0,0-.624,1.515A1.835,1.835,0,0,0,69.636,11.177Z",
    transform: "translate(-44.333 -6.9)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M75.6,12.346V7h.8l2.584,4.188h0V7H79.7v5.346h-.713L76.224,7.98h0v4.366Z",
    transform: "translate(-45.129 -6.911)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M65.156,21.288a3.748,3.748,0,0,0-3.831,3.831,3.8,3.8,0,0,0,3.831,3.831,3.748,3.748,0,0,0,3.831-3.831A3.7,3.7,0,0,0,65.156,21.288Zm0,6.059a2.324,2.324,0,0,1,0-4.633,2.158,2.158,0,0,1,2.138,2.317A2.212,2.212,0,0,1,65.156,27.346ZM56.87,21.288a3.748,3.748,0,0,0-3.831,3.831A3.8,3.8,0,0,0,56.87,28.95,3.748,3.748,0,0,0,60.7,25.119,3.7,3.7,0,0,0,56.87,21.288Zm0,6.059a2.324,2.324,0,0,1,0-4.633,2.158,2.158,0,0,1,2.138,2.317A2.212,2.212,0,0,1,56.87,27.346Zm-9.89-4.9v1.6h3.831a3.369,3.369,0,0,1-.891,2.049,3.944,3.944,0,0,1-2.94,1.158,4.148,4.148,0,0,1-4.188-4.277A4.2,4.2,0,0,1,46.98,18.7a4.418,4.418,0,0,1,2.94,1.158L51.079,18.7a5.709,5.709,0,0,0-4.009-1.6,6.01,6.01,0,0,0-5.97,5.88,6.01,6.01,0,0,0,5.97,5.88,5.128,5.128,0,0,0,4.1-1.693,5.364,5.364,0,0,0,1.426-3.742,3.341,3.341,0,0,0-.089-.98Zm40.45,1.247a3.462,3.462,0,0,0-3.207-2.406,3.588,3.588,0,0,0-3.564,3.831A3.729,3.729,0,0,0,84.4,28.95a3.655,3.655,0,0,0,3.118-1.693l-1.247-.891A2.172,2.172,0,0,1,84.4,27.435a1.933,1.933,0,0,1-1.871-1.158l5.079-2.138Zm-5.168,1.247a2.164,2.164,0,0,1,1.96-2.227,1.576,1.576,0,0,1,1.426.8Zm-4.188,3.653h1.693V17.456H78.075Zm-2.673-6.5h0a2.934,2.934,0,0,0-2.049-.891A3.828,3.828,0,0,0,69.7,25.03a3.689,3.689,0,0,0,3.653,3.742,2.558,2.558,0,0,0,1.96-.891H75.4v.535a2.026,2.026,0,0,1-3.92.891l-1.426.624a3.676,3.676,0,0,0,3.386,2.227c1.96,0,3.564-1.158,3.564-3.92V21.466H75.4Zm-1.96,5.257a2.324,2.324,0,0,1,0-4.633,2.144,2.144,0,0,1,2.049,2.317A2.144,2.144,0,0,1,73.442,27.346Zm21.74-9.89H91.173V28.594h1.693V24.406h2.317a3.479,3.479,0,1,0,0-6.95Zm.089,5.346H92.865V18.971h2.406a1.957,1.957,0,0,1,1.96,1.871A2.039,2.039,0,0,1,95.271,22.8Zm10.246-1.6a3,3,0,0,0-2.94,1.693l1.515.624a1.574,1.574,0,0,1,1.515-.8,1.674,1.674,0,0,1,1.782,1.426v.089a3.534,3.534,0,0,0-1.693-.445c-1.6,0-3.207.891-3.207,2.495a2.61,2.61,0,0,0,2.762,2.495,2.507,2.507,0,0,0,2.138-1.069h.089v.891h1.6V24.317A3.372,3.372,0,0,0,105.517,21.2Zm-.178,6.148c-.535,0-1.336-.267-1.336-.98,0-.891.98-1.158,1.782-1.158a3.446,3.446,0,0,1,1.515.356A2.075,2.075,0,0,1,105.339,27.346Zm9.355-5.88-1.871,4.811h-.089l-1.96-4.811h-1.782l2.94,6.771-1.693,3.742h1.693l4.544-10.513ZM99.726,28.594h1.693V17.456H99.726Z",
    transform: "translate(-4.481 -1.864)",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(8.91 6.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M10.356,7.5A1.742,1.742,0,0,0,10,8.747v19.69a1.763,1.763,0,0,0,.445,1.247l.089.089L21.583,18.726v-.178L10.356,7.5Z",
    transform: "translate(-10 -7.186)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M26.553,23.373,22.9,19.72v-.267L26.553,15.8l.089.089,4.366,2.495c1.247.713,1.247,1.871,0,2.584l-4.455,2.406Z",
    transform: "translate(-11.406 -8.091)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M25.279,23.742,21.537,20,10.4,31.137c.445.445,1.069.445,1.871.089l13.008-7.484",
    transform: "translate(-10.044 -8.549)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M25.279,14.859l-13.008-7.4a1.444,1.444,0,0,0-1.871.089L21.537,18.6Z",
    transform: "translate(-10.044 -7.15)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 15.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M25.19,24.1,12.271,31.406a1.457,1.457,0,0,1-1.782,0h0L10.4,31.5h0l.089.089h0a1.457,1.457,0,0,0,1.782,0L25.19,24.1Z",
    transform: "translate(-10.044 -24.1)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M10.356,32.147A1.742,1.742,0,0,1,10,30.9v.089a1.763,1.763,0,0,0,.445,1.247v-.089Z",
    transform: "translate(-10 -24.841)",
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M31.455,21.158,27,23.653l.089.089,4.366-2.495A1.481,1.481,0,0,0,32.346,20h0C32.346,20.445,31.989,20.8,31.455,21.158Z",
    transform: "translate(-11.854 -8.549)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M12.227,7.551,29.6,17.44c.535.356.891.713.891,1.158h0a1.481,1.481,0,0,0-.891-1.247L12.227,7.462C10.98,6.749,10,7.283,10,8.709V8.8C10,7.462,10.98,6.838,12.227,7.551Z",
    transform: "translate(-10 -7.147)",
    fill: "#fff",
    opacity: 0.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.6a675242635e942d3c8e5b5ee57a1d98.svg";
export { ForwardRef as ReactComponent };